import { render, staticRenderFns } from "./WaitBillList.vue?vue&type=template&id=aff6b6d8&scoped=true"
import script from "./WaitBillList.vue?vue&type=script&lang=js"
export * from "./WaitBillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff6b6d8",
  null
  
)

export default component.exports